import { render } from "./EventDetails.vue?vue&type=template&id=4c5f440e"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import "./EventDetails.vue?vue&type=style&index=0&id=4c5f440e&lang=css"
script.render = render

export default script